import { useState } from "react";
import {
  AmazonItemsApi,
  ResponseRegistAmazonItemsResponse,
  RequestUpdateAmazonItemsRequest,
  AmazonItemsUpdateAmazonItemsPostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiUpdateAmazonItems = () => {
  const [_, setRegistedItem] =
    useState<ResponseRegistAmazonItemsResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateAmazonItems = async (req: RequestUpdateAmazonItemsRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: AmazonItemsUpdateAmazonItemsPostRequest = {
        req,
      };

      const api = new AmazonItemsApi(config);
      const response = await api.amazonItemsUpdateAmazonItemsPost(request);
      setRegistedItem(response);
      return response;
    } catch (err) {
      setError("商品の登録に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateAmazonItems, error, isLoading };
};
